/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import parse from 'html-react-parser';

class StoreStoryItem extends PureComponent {
  state = {
    chuchon: this.props.childProps.chuchon ? this.props.childProps.chuchon : 0,
    likes: this.props.childProps.likes ? this.props.childProps.likes : 0,
  };
  _goDetail = () => {
    const { history } = this.props;
    const { idx, id } = this.props.childProps;

    history.push('/storyItem/' + id + '/' + idx);
  };
  _onNaver = () => {
    const { idx, id, title } = this.props.childProps;
    const url = 'http://www.aniplustv.com/storyItem/' + id + '/' + idx;
    window.open(
      'http://share.naver.com/web/shareView.nhn?url=' +
        encodeURIComponent(url) +
        '&title=' +
        encodeURIComponent(title),
      'naversharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onTwitter = () => {
    const { idx, id, title } = this.props.childProps;
    const url = 'http://www.aniplustv.com/storyItem/' + id + '/' + idx;
    window.open(
      'https://twitter.com/intent/tweet?text=[%EA%B3%B5%EC%9C%A0]%20' +
        encodeURIComponent(url) +
        '%20-%20' +
        encodeURIComponent(title ? title : document.title),
      'twittersharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onFacebook = () => {
    const { idx, id, title } = this.props.childProps;
    const url = 'http://www.aniplustv.com/storyItem/' + id + '/' + idx;
    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' +
        encodeURIComponent(url) +
        '&t=' +
        encodeURIComponent(title ? title : document.title),
      'facebooksharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onInstar = () => {
    const { idx, id } = this.props.childProps;
    const url = 'http://www.aniplustv.com/storyItem/' + id + '/' + idx;
    window.open(
      'https://plus.google.com/share?url=' + encodeURIComponent(url),
      'googleplussharedialog',
      'menubar=no,toolbar=no,resizable=yes, scrollbars=yes,height=350,width=600'
    );
  };
  _onKakao = () => {
    const { idx, id } = this.props.childProps;
    const url = 'http://www.aniplustv.com/storyItem/' + id + '/' + idx;
    window.open(
      'https://story.kakao.com/s/share?url=' + encodeURIComponent(url),
      'kakaostorysharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes, height=400,width=600'
    );
  };
  _onLike = async () => {
    const { loginId } = this.props;
    const { chuchon } = this.state;

    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인 후 이용해 주세요.');
      return false;
    } else {
      const result = await this._onLikeApi();
      const intReturn = result.data[0].intReturn;

      if (intReturn === 0) {
        //좋아요 성공
        toast.success('좋아요가 추가되었습니다.');
        this.setState({
          likes: 100,
          chuchon: chuchon + 1,
        });
      } else {
        toast.warn('좋아요가 취소되었습니다.');
        this.setState({
          likes: 0,
          chuchon: chuchon - 1,
        });
        //좋아요 취소
      }
    }
  };
  _onLikeApi = () => {
    const { apiUrl, loginId } = this.props;
    const { idx } = this.props.childProps;

    return axios
      .post(apiUrl + '/storeLike', {
        params: {
          idx: idx,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  render() {
    const {
      id,
      storeName,
      categoryName,
      title,
      readnum,

      writeday,
      filename,
      content,
      active,
    } = this.props.childProps;
    const { chuchon, likes } = this.state;
    const { imgUrl } = this.props;
    let storeClass;

    if (id === 'hapjung') {
      storeClass = 'store_card su_hj';
    } else if (id === 'daejeon') {
      storeClass = 'store_card dj_ja';
    } else if (id === 'gwangju') {
      storeClass = 'store_card gj_cj';
    } else if (id === 'busan') {
      storeClass = 'store_card bs_sm';
    }
    return (
      <Fragment>
        <div className={storeClass}>
          {/* 카드 상단/ */}
          <div className="store_card_top">
            <span className="tag">
              [{storeName}] {categoryName}
            </span>
            <ul className="store_card_top_rt">
              <li className="store_card_ico">
                <span
                  className={
                    parseInt(likes) > 0 ? 'ico_like active' : 'ico_like'
                  }
                  onClick={this._onLike}
                ></span>
                <span className="num">{chuchon}</span>
              </li>
              <li className="store_card_ico">
                <span className="ico_read"></span>
                <span className="num">{readnum}</span>
              </li>
              <li className="store_card_ico btn_more">
                <span className="ico_more"></span>
                <ul className="more_wrap">
                  <li>
                    <a onClick={this._onFacebook} style={{ cursor: 'pointer' }}>
                      <img
                        src={imgUrl + '/img/store/sns_fb.png'}
                        alt="페이스북"
                      />
                    </a>
                  </li>
                  <li>
                    <a onClick={this._onKakao} style={{ cursor: 'pointer' }}>
                      <img
                        src={imgUrl + '/img/store/sns_kako.png'}
                        alt="카카오"
                      />
                    </a>
                  </li>
                  <li>
                    <a onClick={this._onInstar} style={{ cursor: 'pointer' }}>
                      <img
                        src={imgUrl + '/img/store/sns_google.png'}
                        alt="구글"
                      />
                    </a>
                  </li>
                  <li>
                    <a onClick={this._onTwitter} style={{ cursor: 'pointer' }}>
                      <img
                        src={imgUrl + '/img/store/sns_twt.png'}
                        alt="트위터"
                      />
                    </a>
                  </li>
                  <li>
                    <a onClick={this._onNaver} style={{ cursor: 'pointer' }}>
                      <img
                        src={imgUrl + '/img/store/sns_naver.png'}
                        alt="네이버"
                      />
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          {/* 카드 타이틀/ */}
          <div className="store_card_tit">
            <p className="date">
              <span>
                {writeday}
                {active === false ? (
                  <span style={{ color: 'red' }}> [비활성]</span>
                ) : null}
              </span>
            </p>
            <p className="tit" onClick={this._goDetail}>
              {title}
            </p>
            <p className="summary" onClick={this._goDetail}>
              {parse(content)}
            </p>
          </div>
          {/* 카드 썸네일/ */}
          {filename === '' ||
          filename === undefined ||
          filename === null ? null : (
            <div className="store_card_thumb" onClick={this._goDetail}>
              <img src={filename} />
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}
export default shopContext(withRouter(React.memo(StoreStoryItem)));
